import {react2panel} from 'common/util/react2panel';

import {ToastReact} from './';

export const ToastEl = react2panel(`mp-toast`, ToastReact);
